import Vue from "vue";

const getDefaultState = () => {
  return {
    propertyNameInput: "",

    creatingProperty: false, // Whether user is currently in the process of creating a property.
  };
};

const state = Vue.observable(getDefaultState());

const methods = {
  RESET_STATE() {
    Object.assign(state, getDefaultState());
  },
  setPropertyNameInput(newValue) {
    state.propertyNameInput = newValue;
  },
  setCreatingProperty(newValue) {
    state.creatingProperty = newValue;
  },
};

const PropertyStore = {
  state,
  methods,
};
export default PropertyStore;
